export default __webpack_public_path__ + "static/media/confirm-email.828e83fd.png";